const prodjectCategory = [
    { id: 1, label: "Flutter", value: "flutter" },
    { id: 2, label: "Java", value: "java" },
    { id: 3, label: "React Native", value: "reactNative" },
    { id: 4, label: "PHP", value: "php" },
    { id: 5, label: "React", value: "react" },
    { id: 6, label: "MERN", value: "mern" },
    { id: 7, label: "Angular", value: "angular" },
    { id: 8, label: "Spring Boot", value: "springboot" },
    { id: 9, label: "Laravel", value: "laravel" },
    { id: 10, label: "Python with ML", value: "python-ml" },
    { id: 11, label: "Android Studio", value: "android" },
    { id: 12, label: "Unity", value: "unity" },
    { id: 13, label: "JavaScript", value: "javascript" },
    { id: 14, label: "NodeJS", value: "nodejs" },
    { id: 15, label: "C", value: "c" },
    { id: 16, label: "C++", value: "c++" },
]

export default prodjectCategory